import { gql } from "urql";
export const CreateBugReportMutation = gql `
    mutation CreateBugReport($message: String!) {
        bugReports {
            createBugReport(message: $message) {
                success
            }
        }
    }
`;
